import React from "react";
import PropTypes from "prop-types";
import humanizeString from "string-humanize";
import ProtectedContent from "../protectedContent";

const PopoverItem = (props) => {
  const {onContentSelection = () => {}, label, icon: Icon, perms = []} = props;
  return (
    <ProtectedContent perms={perms}>
      <div
        style={{
          padding: "5px 3px",
        }}
        className={"content_item roboto-normal"}
        onClickCapture={() => onContentSelection(label)}
        data-cy={`list_${label}`}
      >
        <span className={"content_item_text"}>
          <Icon aria-hidden="true" /> {humanizeString(label)}
        </span>
      </div>
    </ProtectedContent>
  );
};

PopoverItem.propTypes = {
  /** Text to be displayed on item*/
  label: PropTypes.string.isRequired,
  /** icon which will be displayed on left side of popover item.
   *  This is icon component from react-icons library which will be used as Element
   */
  icon: PropTypes.elementType.isRequired,
  /** Callback function which will be executed on click of popover item */
  onContentSelection: PropTypes.func,
  /** permission required for user to view this component.
   *  This will be passed to protected content component
   */
  perms: PropTypes.array,
};

export default PopoverItem;
